module.exports = __webpack_public_path__ + "static/media/18ECA42.a942e82e.jpg";